import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Button } from '@material-ui/core';

import * as PublicStore from '../../../app/store/PublicStore';
import urls from '../../../app/urls';

const styles = theme => ({
    root: {
        margin: theme.spacing(4, 0, 2),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    button: {
        textTransform: 'none',
    },
});

const useStyles = makeStyles(theme => styles(theme), { name: 'Footer' });

const Footer = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const translate = useSelector(state => getTranslate(state.localize));
    const currentProgramId = useSelector(state => state.publicStore.currentProgramId);
    const patientProgramElementId = useSelector(state => state.publicStore.patientProgramElementId);

    if (!patientProgramElementId) {
        return null;
    }

    const endSession = () => {
        const redirect = `${urls.public.program}/${currentProgramId}`;
        dispatch(PublicStore.actionCreators.endSession(PublicStore.endSessionReasons.manualEnd, redirect));
    };

    return (
        <div className={classes.root}>
            <Button onClick={endSession} className={classes.button}>
                {translate('public.endSession')}
            </Button>
        </div>
    );
};

export default Footer;
